import { createFileRoute } from '@tanstack/react-router';
import BaseView from 'containers/Base/BaseView';
import { baseModuleConfigs } from 'containers/Base/baseModuleConfigs';
import { useJobMutations } from 'containers/Jobs/useJobMutations';
import { prefetchGridSchema } from '../-utils/loaders';

function JobsRoute() {
  const { customAdd, customChange, customDelete } = useJobMutations();
  return (
    <BaseView
      configuration={baseModuleConfigs.Jobs}
      customAdd={customAdd}
      customChange={customChange}
      customDelete={customDelete}
    />
  );
}

export const Route = createFileRoute('/_authenticated/jobs')({
  loader: ({ context }) =>
    prefetchGridSchema(context.queryClient, baseModuleConfigs.Jobs.itemType),
  component: JobsRoute,
});
